import useCurrentDate from "../../../Utils/useCurrentDate";
import _ from "underscore";
import { tableFill, tableTranspose } from "../../../API/course";
import { useMemo } from "react";
import moment from "moment";
import { CourseItem } from "../../../API";

export interface DayItems {
    day: string;
    courses: CourseItem[];
    date: string;
}

export interface WeekCalendarProps {
    startDate: string;
    endDate: string;
    data: DayItems[];
}

export interface WeekDay {
    day: moment.Moment;
    date: string;
    isToday: boolean;
}

export default function useWeekCalendar({
    data,
    endDate,
    startDate
}: WeekCalendarProps) {
    const { time } = useCurrentDate();

    // 简化为二维数组
    const table1 = _.pluck(data, "courses");

    const minColumnCount = useMemo(() => {
        return _.reduce(
            table1,
            (memo, item) => {
                return Math.max(_.compact(item).length, memo);
            },
            4
        );
    }, [table1]);

    // 用指定尺寸填充表格
    const table2 = tableFill(table1, {
        rows: 7,
        columns: minColumnCount,
        fill: undefined
    });

    // 行列互换
    const table3 = tableTranspose(table2);

    // 一周的每天
    const weekDays = useMemo(() => {
        const days = new Array(7)
            .fill(1)
            .map((ful, index) => moment(startDate).add(index, "d"));
        return days.map(day => ({
            day,
            date: day.format("YYYY-MM-DD"),
            isToday: day.isSame(time, "day")
        }));
    }, [startDate, endDate]);

    return { weekDays, table: table3 };
}
